import { registerFeatureWithDescription } from "lib/features"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SHARE_LINK_COMMENTS } from "./share-link-comments-feature-flag"

// Part of the share-link collaboration loop: lets an internal regime editor action share-link
// comments on content by overriding the master title, introduction and task text during tailoring —
// stored on the regime payload, so other tailoring edits and the comment threads are preserved
// (no derived schedule fork). Ships dark until promoted.
export const FEATURE_FLAG_SHARE_LINK_CONTENT_OVERRIDES = registerFeatureWithDescription({
    numericalId: 25,
    id: "share-link-content-overrides",
    name: "Share-Link Content Overrides",
    internalUseOnly: true,
    descriptionLines: [
        "Allows internal regime editors to override the master title, introduction and task content",
        "text when actioning share-link comments, keeping other tailoring edits and comment threads intact.",
    ],
})

// The override editors are scoped to the share-link collaboration set: the client must have
// Share-Link Comments (the capability these overrides exist to action) AND this rollout flag. Used
// both inside the editor and as the plug-level `if` gate, so the inline editors only ever replace the
// stock content for collaboration clients — never for ordinary regime tailoring.
export function isShareLinkContentOverrideEnabled() {
    return isEnabled(FEATURE_FLAG_SHARE_LINK_COMMENTS) && isEnabled(FEATURE_FLAG_SHARE_LINK_CONTENT_OVERRIDES)
}
